export default __webpack_public_path__ + "static/2019_13-c90c0ad86ecc7bd92762f004d43a9682.png";